import { type FC, type PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'

import { BrandIllustration } from '../../../../brand-illustration'

export const ProductPageOdsDialogOnlineDoctorSection: FC<
  PropsWithChildren<{ className?: string }>
> = ({ children, className }) => {
  const intl = useIntl()

  return (
    <section className={className} id="online-doctor">
      <BrandIllustration
        alt={intl.formatMessage({
          id: 'pdp.buyboxwithvariants.odsModal.onlineConsultation.image.alt',
        })}
        className="mx-auto mb-5 shrink-0"
        name="ods-consultation"
        size="s"
        type="dark"
      />
      {children}
    </section>
  )
}
